module.exports = "images/enfants_4.b77cbc34.png";